import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ads-breadcrumb',
  templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent implements OnInit {

  constructor() { }
  @Input("nameKey") nameKey: string = 'nameKey';
  @Input("isVisibleKey") isVisibleKey: string = 'isVisibleKey';//default=true
  @Input("isEnableKey") isEnableKey: string = 'isEnableKey';//default=true
  @Input("isClickableKey") isClickableKey: string = 'isClickableKey';//default=true
  @Input("breadcrumbDivider") breadcrumbDivider: string = 'arrow_forward_ios ';//default=true
  @Input("style") style: string = "";
  @Input("class") class: string = '';//default=true
  @Input("datasource") datasource: any[] = [];
  @Output("onItemClick") onItemClickEmitter = new EventEmitter();
  ngOnInit(): void {
  }
  getMappedBoolValue(item, key) {
    return typeof (item[key]) == 'boolean' ? item[key] : true;
  }
  itemClick(event) {
    this.onItemClickEmitter.emit(event);
  }
}
